import { useEffect, useState } from 'react'
import { getAllDeportes } from '../lib/supabase'
import { getSportLabel, normalizeSportValue } from '../constants/sports'

// Nombres de deporte desde la BD, no desde la lista hardcodeada.
//
// src/constants/sports.js trae SPORTS = [flag, tackle] a mano, y getSportLabel
// devuelve el ID CRUDO cuando no lo encuentra. Resultado: la tabla `deportes` dice
// "Flag Football" y el hardcode dice "Flag" (ya divergian), y un deporte nuevo
// -- p. ej. Fitness -- se veria como "fitness" en minuscula.
//
// El catalogo es diminuto y casi nunca cambia, asi que se carga una vez por
// pantalla. Cache a nivel de modulo: no tiene sentido re-consultarlo en cada
// componente que necesite un nombre.
let cache = null

export const useDeportes = () => {
  const [deportes, setDeportes] = useState(cache || [])

  useEffect(() => {
    if (cache) return
    let alive = true
    // Un hook que solo da nombres nunca debe tumbar la pantalla: si la consulta falla (o
    // no existe, como en una prueba), se queda con los nombres de respaldo.
    Promise.resolve()
      .then(() => getAllDeportes())
      .then((res) => {
        if (res?.data) cache = res.data
        if (alive) setDeportes(res?.data || [])
      })
      .catch(() => {})
    return () => { alive = false }
  }, [])

  // Nombre real; si el catalogo aun no carga (o el deporte no existe), cae al
  // hardcode -- que al menos capitaliza flag/tackle -- y nunca a un id crudo.
  const label = (deporteId) => {
    if (!deporteId) return 'Sin definir'
    const id = normalizeSportValue(deporteId)
    // "todos" no es un deporte: es la prenda o plantilla que sirve para cualquiera.
    if (id === 'todos') return 'Todos los deportes'
    const match = deportes.find((d) => d.id === id)
    return match?.nombre || getSportLabel(deporteId)
  }

  return { deportes, label }
}
